import { cloudFunction } from "@/api/firebase/callCloudFunctions";
import { Profile } from "@/models/Profile.model";
import { Button, Container, Heading, Flex, Card } from "@radix-ui/themes";
import { FC, JSX } from "react";

interface UsersOverviewUIProps {
  users?: Profile[];
}

const UsersOverviewUI: FC<UsersOverviewUIProps> = ({ users }): JSX.Element => {
  const setAdminUser = async (uid: string) => {
    try {
      const response = await cloudFunction("setAdmin", {
        uid: uid,
      });
      console.log(response.data);
    } catch (err) {
      console.error("Error calling cloud function:", err);
    }
  };

  const removeAdminUser = async (uid: string) => {
    try {
      const response = await cloudFunction("removeAdmin", {
        uid: uid,
      });
      console.log(response.data);
    } catch (err) {
      console.error("Error calling cloud function:", err);
    }
  };

  if (!users) {
    return (
      <Container>
        <Heading as="h1">No users found</Heading>
      </Container>
    );
  }

  return (
    <Container>
      <Heading as="h1">Users</Heading>
      <Flex direction="column" gap="4">
        {users.map((user) => (
          <Card key={user.uid}>
            <Flex justify="between">
              {user.firstName} {user.lastName} - {user.email}
              <Flex gap="3">
                <Button onClick={() => setAdminUser(user.uid)}>
                  Make admin
                </Button>
                <Button onClick={() => removeAdminUser(user.uid)}>
                  Remove admin
                </Button>
              </Flex>
            </Flex>
          </Card>
        ))}
      </Flex>
    </Container>
  );
};

export default UsersOverviewUI;
